module.exports = __webpack_public_path__ + "media/pickedAnother.3af13bd5.mp3";